<template>
    <div class="ur-carousel" :style="compoStyle" :class="compoClass">
        <div class="ur-carousel__window" :style="itemStyle">
            <div class="ur-carousel__left-move" @click="moveTick(-1)" :class="leftCarotClass">
                <ur-icon md type="picto">collapse_menu</ur-icon>
            </div>
            <div class="ur-carousel__item-wrapper" :style="wrapperStyle"><!--
                $ver: v0.1.0
                <em>ur-carousel-item</em> 컴포넌트들로 구성되는 컨텐츠 영역입니다.
                #A content area consisting of <em>ur-carousel-item</em> components.
             --><slot/>
            </div>
            <div class="ur-carousel__right-move" @click="moveTick(1)" :class="rightCarotClass">
                <ur-icon md type="picto">collapse_menu</ur-icon>
            </div>
        </div>
        <!-- [PAGER] -->
        <template v-if="isDot">
            <div class="ur-carousel__pager ur-carousel__pager-wrapper" :style="pagerStyle">
                <div v-for="n in itemCount" class="ur-carousel__pager-dot"
                    :class="pagerClass(n)" @click="goARound(n)" :key="n"/>
            </div>
        </template>
        <template v-if="isThumb">
            <div class="ur-carousel__pager" :style="pagerStyle">
                <div class="ur-carousel__pager-caret-left" @click="moveTick(-1)">
                    <ur-icon sm type="picto">collapse_menu</ur-icon>
                </div>
                <div class="ur-carousel__pager-window">
                    <div class="ur-carousel__pager-wrapper" :style="thumbWrapperStyle">
                        <img v-for="(src,i) in thumbList" class="ur-carousel__pager-thumb"
                            :src="src" :class="pagerClass(i+1)" :style="thumbStyle"
                            @click="goARound(i+1)" :key="i"/>
                    </div>
                </div>
                <div class="ur-carousel__pager-caret-right" @click="moveTick(+1)">
                    <ur-icon sm type="picto">collapse_menu</ur-icon>
                </div>
            </div>
        </template>


    </div>
</template>

<script>

    const DEFAULT_WIDTH  = 460;
    const DEFAULT_HEIGHT = 210;
    const THUMB_IMG_WIDTH  = 54;
    const THUMB_IMG_HEIGHT = 41;
    // ur-carousel은 내부 컨텐츠를 로테이션 시키며 사용자에게 보여주는 역할을 합니다.
    // #The v-carousel component is used to display content on a rotating mover.
    export default {
    name: 'urCarousel',
    props: {
        // $ver: v0.1.0
        // 너비를 지정합니다. 단위는 px 입니다.
        // #Specify the width. The unit is px.
        // $default: 460
        width : { type: [Number,String], default: DEFAULT_WIDTH },

        // $ver: v0.1.0
        // 높이를 지정합니다. 단위는 px 입니다.
        // #Specify the height. The unit is px.
        // $default: 210
        height: { type: [Number,String], default: DEFAULT_HEIGHT },

        // $ver: v0.1.0
        // $abbr: width
        w : { type: [Number,String] },

        // $ver: v0.1.0
        // $abbr: height
        h : { type: [Number,String] },

        // $ver: v0.1.0
        // 페이징 영역을 Dot 유형으로 표현합니다.
        // #Paging area is represented by Dot type.
        // $default: true
        dot       : {type:Boolean,default:true},

        // $ver: v0.1.0
        // 페이징 영역을 썸네일 유형으로 표현합니다. thumbnail과 같은 속성입니다.
        // #Represents a paging area as a thumbnail type.
        // $default: false
        thumbnail : {type:Boolean,default:false},

        // $ver: v0.1.0
        // $abbr: thumbnail
        // $default: false
        thumb     : {type:Boolean,default:false},

        // $ver: v0.1.0
        // 마지막 페이지에서 다음 버튼으로 첫 페이지로 전환되지 않도록 합니다.
        // #Prevents you from switching to the first page from the last page with the Next button.
        // $default: false
        noRotate  : {type:Boolean,default:false},

        // $ver: v0.1.0
        // 현재 사용되지 않는 Prop 입니다.
        // #Prop not currently used.
        // $deprecated
        initScroll: { type:[Number,String] },
    },
    data() {return {
        scroll : 1,
    }},
    computed: {
        isDot()   {return this.dot && !this.isThumb},
        isThumb() {return this.thumb || this.thumbnail},
        nWidth() {
            let val = this.w || this.width;
            return parseInt(val) || DEFAULT_WIDTH;
        },
        nHeight() {
            let val = this.h || this.height ;
            return parseInt(val) || DEFAULT_WIDTH;
        },
        compoClass() {
            return {'ur-carousel--thumb':this.isThumb};
        },
        compoStyle() {return {width:this.nWidth+"px"}},
        itemStyle() {return {width:this.nWidth+"px",height:this.nHeight+"px"}},
        pagerStyle() {return {width:this.nWidth+"px"}},
        wrapperStyle() { return {
            'width'      : this.nWidth*this.itemCount+"px",
            'height'     : this.nHeight+"px",
            'margin-left': (this.nWidth*(1-this.scroll))+"px"
        }},
        thumbStyle()       {return {width:THUMB_IMG_WIDTH+"px",height:THUMB_IMG_HEIGHT+"px"}},
        thumbWindowStyle() {return {width:this.nWidth+"px",height:THUMB_IMG_HEIGHT+"px"}},
        thumbWrapperStyle(){
            let w = this.nWidth;
            let wrapperWidth = (THUMB_IMG_WIDTH+8)*this.itemCount;
            let diff = wrapperWidth - 8 - w;
            let lMargin = -4;
            if( diff > 0 ) {
                lMargin -= parseInt((this.scroll-1) * (diff /(this.itemCount-1)));
            }
            return {
                "width"      :wrapperWidth + "px",
                "height"     :THUMB_IMG_HEIGHT + "px",
                "margin-left":lMargin + "px"
            };
        },
        leftCarotClass() {
            return {"ur-carousel__move--block":this.noRotate&&this.scroll===1}
        },
        rightCarotClass() {
            return {"ur-carousel__move--block":this.noRotate&&this.scroll===this.itemCount}
        },

        sharedData() {
            let rtn = {}, odf = Object.defineProperty;
            odf(rtn, "width"  , {get:()=>this.nWidth});
            odf(rtn, "height" , {get:()=>this.nHeight});
            odf(rtn, "iStyle" , {get:()=>this.itemStyle});
            return rtn;
        },
        itemCount() {
            let slot = this.$slots['default'], cnt=0;
            if(!!slot){
                slot.forEach(item => {
                    if(!item.componentOptions) return;
                    let name = item.componentOptions.Ctor.options.name;
                    if(name === 'urCarouselItem') cnt++;
                })
            }
            return cnt;
        },
        thumbList() {
            let slot = this.$slots['default'], arr = [];
            if(!!slot){
                slot.forEach(item => {
                    if(!item.componentOptions) return;
                    let name = item.componentOptions.Ctor.options.name;
                    if(name !== 'urCarouselItem') return;
                    arr.push(item.componentOptions.propsData.thumb);
                })
            }
            return arr;
        }
    },
    created() {

    },
    provide() {return {carousel:this.sharedData}},
    methods: {
        // @vuese
        // $ver: v0.1.0
        // $arg: Number - 이동할 페이지 번호
        // $return: N/A
        // 지정한 페이지로 보여지는 컨텐츠가 바뀝니다.
        // #The content shown on the specified page changes.
        goARound(n) {
            this.scroll = n;
            this.moveEmit(this.scroll);
        },

        pagerClass(n) {
            let clazz = [];
            if(n === this.scroll) { clazz.push('ur-carousel__pager--active'); }
            return clazz;
        },
        moveTick(of) {
            this.scroll += of;

            if( this.scroll > this.itemCount ) {this.scroll = this.noRotate?this.itemCount:1;}
            if( this.scroll < 1 ) {this.scroll = this.noRotate?1:this.itemCount;}
            this.moveEmit(this.scroll);
        },
        moveEmit(nextPage){
            this.$emit('move', nextPage);
        }
    }
};


</script>
